import React from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { IconButton } from "@mui/material";
const SocialMediaIcons = ({ top, m }) => {
  return (
    <div
      style={{ position: "absolute", top: top, right: 0 }}
      className="z-30  sm:block"
    >
      <div
        className="bg-[#ffffff] "
        style={{ borderBottomLeftRadius: m ? "30px" : "40px" }}
      >
        <div
          className={
            m
              ? "flex flex-col justify-center py-3 px-4 items-center space-y-3"
              : "flex flex-col justify-center py-4 px-6 items-center space-y-3"
          }
        >
          <IconButton
            style={{
              backgroundColor: "#00693A",
              color: "#ffffff",
              borderRadius: "30%",
              padding: 2,
            }}
            onClick={(e) => {
              e.preventDefault();
              window.location.href =
                "https://www.instagram.com/lebanesegreenwave";
            }}
          >
            <InstagramIcon fontSize={!m ? "medium" : "small"} />
          </IconButton>
          <IconButton
            style={{
              backgroundColor: "#00693A",
              color: "#ffffff",
              borderRadius: "30%",
              padding: 2,
            }}
            onClick={(e) => {
              e.preventDefault();
              window.location.href =
                "https://www.facebook.com/LebaneseGreenWave";
            }}
          >
            <FacebookIcon fontSize={!m ? "medium" : "small"} />
          </IconButton>
          <IconButton
            style={{
              backgroundColor: "#00693A",
              color: "#ffffff",
              borderRadius: "30%",
              padding: 2,
            }}
            onClick={(e) => {
              e.preventDefault();
              window.location.href =
                "https://www.youtube.com/channel/UC1CE-w_I09k7_1RnwsEjVgQ";
            }}
          >
            <YouTubeIcon fontSize={!m ? "medium" : "small"} />
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaIcons;
